(function () {
    const platform = UG.platform;
    const domain = document.domain;
    // 国内域名和国外域名
    const inlandHost = 'h5.upliveapp.com';
    const foreignHost = 'm.upliveapps.com';
    // 是国内还是国外
    const isInland = domain === inlandHost;
    const isForeign = domain === foreignHost;
    const href = location.href;

    // m域名在微信/qq/微博无法登录问题。
    // 判断页面若在微信中打开，则先跳转到h5域名下，然后再登录，QQ、微博同理。
    // 相反，h5域名网址若在FB中打开，则先跳转到m域名，然后执行登录。
    if (['wechat', 'qq', 'weibo', 'renren'].indexOf(platform) !== -1 && isForeign) {
        location.replace(href.replace(foreignHost, inlandHost));
    } else if (['fb'].indexOf(platform) !== -1 && isInland) {
        location.replace(href.replace(inlandHost, foreignHost));
    }
})();



// WEBPACK FOOTER //
// ./js/component/fithost/index.js